import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class IntegrationService {
  httpClient = inject(HttpClient);

  constructor() {}

  getCloverAuthorization(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/clover/auth').pipe(
      catchError((error) => {
        console.error('Error fetching clover authorization:', error);
        return of(error);
      }),
    );
  }

  getCloverConnectionStatus(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/clover/check_status').pipe(
      catchError((error) => {
        console.error('Error fetching clover connection status:', error);
        return of(error);
      }),
    );
  }

  cloverConnectionCallback(queryParams: any): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/clover/callback?' + queryParams)
      .pipe(
        catchError((error) => {
          console.error('Error fetching clover connection call back:', error);
          return of(error);
        }),
      );
  }

  cloverMigration(data: any): Observable<any> {
    return this.httpClient.post<any>(ServiceConstant.apiUrl + '/clover/migrate', data).pipe(
      catchError((error) => {
        console.error('Error migrating clover data:', error);
        return of(error);
      }),
    );
  }

  getUberEatsAuthorization(): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/auth-info')
      .pipe(
        catchError((error) => {
          console.error('Error fetching uber eats authorization:', error);
          return of(error);
        }),
      );
  }

  getUberEatsConnectionStatus(): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/check_status/')
      .pipe(
        catchError((error) => {
          console.error('Error fetching uber eats connection status:', error);
          return of(error);
        }),
      );
  }

  uberEatsConnectionCallback(queryParams: any): Observable<any> {
    return this.httpClient
      .get<any>(
        ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/oauth/callback?' + queryParams,
      )
      .pipe(
        catchError((error) => {
          console.error('Error fetching uber eats connection call back:', error);
          return of(error);
        }),
      );
  }

  uberEatsMigration(data: any): Observable<any> {
    return this.httpClient
      .post<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/sync', data)
      .pipe(
        catchError((error) => {
          console.error('Error migrating uber eats data:', error);
          return of(error);
        }),
      );
  }

  changeUberEatsAutoApprove(data: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/restaurants/settings/delivery/toggle', data)
      .pipe(
        catchError((error) => {
          console.error('Error changing uber eats auto approve:', error);
          return of(error);
        }),
      );
  }

  changeUberEatsPreparationTime(data: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/restaurants/settings/delivery/preparation-time', data)
      .pipe(
        catchError((error) => {
          console.error('Error changing uber eats preparation time:', error);
          return of(error);
        }),
      );
  }

  uberEatsRestusurentStaus(): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/completed')
      .pipe(
        catchError((error) => {
          console.error('Error fetching uber eats restusurent status:', error);
          return of(error);
        }),
      );
  }

  disconnectUberEats(): Observable<any> {
    return this.httpClient
      .delete<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats')
      .pipe(
        catchError((error) => {
          console.error('Error disconnecting uber eats:', error);
          return of(error);
        }),
      );
  }

  getUberStoreStatus(): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/store-status')
      .pipe(
        catchError((error) => {
          console.error('Error fetching uber store status:', error);
          return of(error);
        }),
      );
  }

  changeUberStoreStatus(data: any): Observable<any> {
    return this.httpClient
      .post<any>(ServiceConstant.apiUrl + '/deliveries/integrations/uber-eats/store-status', data)
      .pipe(
        catchError((error) => {
          console.error('Error changing uber store status:', error);
          return of(error);
        }),
      );
  }

  getSquareAuthorization(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/square/auth').pipe(
      catchError((error) => {
        console.error('Error fetching square authorization:', error);
        return of(error);
      }),
    );
  }

  getSquareConnectionStatus(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/square/check_status').pipe(
      catchError((error) => {
        console.error('Error fetching square connection status:', error);
        return of(error);
      }),
    );
  }

  squareConnectionCallback(queryParams: any): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/square/callback?' + queryParams)
      .pipe(
        catchError((error) => {
          console.error('Error fetching square connection call back:', error);
          return of(error);
        }),
      );
  }

  squareMigration(data: any): Observable<any> {
    return this.httpClient.post<any>(ServiceConstant.apiUrl + '/square/migrate', data).pipe(
      catchError((error) => {
        console.error('Error migrating square data:', error);
        return of(error);
      }),
    );
  }

  getSquareStatus(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/square/check_status').pipe(
      catchError((error) => {
        console.error('Error fetching square connection status:', error);
        return of(error);
      }),
    );
  }

  getSquareOnbiardDetails(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/square/onboarding-details').pipe(
      catchError((error) => {
        console.error('Error fetching square connection status:', error);
        return of(error);
      }),
    );
  }

  getSquareMenus(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/square/menus').pipe(
      catchError((error) => {
        console.error('Error fetching square connection status:', error);
        return of(error);
      }),
    );
  }

  saveSelectedMenus(data: any): Observable<any> {
    return this.httpClient.post<any>(ServiceConstant.apiUrl + '/square/menu-selections', data).pipe(
      catchError((error) => {
        console.error('Error migrating square data:', error);
        return of(error);
      }),
    );
  }

  getSquareLocations(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/square/locations').pipe(
      catchError((error) => {
        console.error('Error fetching square connection status:', error);
        return of(error);
      }),
    );
  }

  saveSelectedLocations(data: any): Observable<any> {
    return this.httpClient
      .post<any>(ServiceConstant.apiUrl + '/square/location-selection', data)
      .pipe(
        catchError((error) => {
          console.error('Error migrating square data:', error);
          return of(error);
        }),
      );
  }

  disconnectSquare(): Observable<any> {
    return this.httpClient.delete<any>(ServiceConstant.apiUrl + '/square/integration').pipe(
      catchError((error) => {
        console.error('Error disconnecting uber eats:', error);
        return of(error);
      }),
    );
  }

  // Swirepay (FNF-1466): unlike Square / Clover there is no OAuth hop — we are
  // a Swirepay partner, so the owner just names their merchant account and
  // shop, swirepay-service validates them against Swirepay and syncs the menu.

  swirepayConnect(data: { account_id: string; shop_gid: string }): Observable<any> {
    return this.httpClient.post<any>(ServiceConstant.apiUrl + '/swirepay/connect', data).pipe(
      catchError((error) => {
        console.error('Error connecting swirepay:', error);
        return of(error);
      }),
    );
  }

  swirepayMigrate(): Observable<any> {
    return this.httpClient.post<any>(ServiceConstant.apiUrl + '/swirepay/migrate', {}).pipe(
      catchError((error) => {
        console.error('Error migrating swirepay data:', error);
        return of(error);
      }),
    );
  }

  getSwirepayStatus(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/swirepay/check_status').pipe(
      catchError((error) => {
        console.error('Error fetching swirepay connection status:', error);
        return of(error);
      }),
    );
  }

  swirepayDisconnect(): Observable<any> {
    return this.httpClient.delete<any>(ServiceConstant.apiUrl + '/swirepay/integration').pipe(
      catchError((error) => {
        console.error('Error disconnecting swirepay:', error);
        return of(error);
      }),
    );
  }
}
